<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import moment from "moment";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED, DATE } from "@/constants";
import { mapState } from "vuex";
import { DOMAIN_MODULE } from '@/state/modules/domain'
import { domainMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: i18n.t("label.listingX", [i18n.t('module.domain')]),
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != 'Domain-update' && to.name != 'Domain-create' && to.name != 'Domain-results') {
      sessionHelper.clearSearch(SESSION.DOMAIN_SEARCH)
    }
    next();
  },
  async created() {
    await this.validPermissions();
    this.initSearchCriteria();
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: i18n.t("label.listingX", [i18n.t('module.domain')]),
      items: [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.domain"),
          active: true,
        },
      ],
      statusDdl: ddlHelper.getActivationStatus(true),
      currentPage: 1,
      filter: "",
      selectedStatus: SHARED.DEFAULT_ALL_VALUE,
      permissions: sessionHelper.getPermissions(),
      createPermission: null,
      updatePermission: null,
      updateStatusPermission: null,
      readPermission: null,
      readAllPermission: null,
      checkPermission: null,
      enabled: false,
      perPage: SHARED.DEFAULT_PAGE_SIZE,
      pageOptions: [10, 25, 50, 100],
      filterOn: [],
      sortBy: "domain",
    };
  },
  computed: {
    selectedStatusOption: {
      get() {
        return this.statusDdl.find((status) => status.value == this.selectedStatus) || null;
      },
      set(option) {
        this.selectedStatus = option ? option.value : null;
      },
    },
    ...mapState(DOMAIN_MODULE, ['status']),
    fields() {
      let fields = [
        { key: "domain", sortable: true, label: i18n.t("label.domain"), },
        { key: "countryCode", sortable: true, label: i18n.t("label.countryCode"), },
      ]

      if (this.readAllPermission == true) {
        fields.push({ key: "ownerName", sortable: true, label: i18n.t("label.owner"), })
      }

      fields.push({ key: "lastStatus", sortable: true, label: i18n.t("label.playerStatus"), })
      fields.push({ key: "problemDetectedAt", sortable: true, label: i18n.t("label.problemDetectedAt"), })
      fields.push({ key: "lastCheckedAt", sortable: true, label: i18n.t("label.lastCheckedAt"), })
      fields.push({ key: "isActive", sortable: true, label: i18n.t("label.status"), })
      fields.push({ key: "Action", sortable: false, label: i18n.t("label.action"), })

      return fields
    },
    tableRows() {
      return this.$store.state.domain.list.data;
    },
    pagination() {
      return this.$store.state.domain.list.pagination;
    },
    totalPage() {
      return this.$store.state.domain.list.pagination.total;
    },
  },
  mounted() { },
  methods: {
    ...domainMethods,
    async validPermissions() {
      var jsonPermissions = JSON.parse(this.permissions)
      if (jsonPermissions.some(p => p.code === "DOMAIN_CREATE")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }

      if (jsonPermissions.some(p => p.code === "DOMAIN_READ")) {
        this.readPermission = true;
      }
      else {
        this.readPermission = false;
      }

      if (jsonPermissions.some(p => p.code === "DOMAIN_READ_ALL")) {
        this.readAllPermission = true;
      }
      else {
        this.readAllPermission = false;
      }

      if (jsonPermissions.some(p => p.code === "DOMAIN_UPDATE")) {
        this.updatePermission = true;
      }
      else {
        this.updatePermission = false;
      }

      if (jsonPermissions.some(p => p.code === "DOMAIN_UPDATE_STATUS")) {
        this.updateStatusPermission = true;
      }
      else {
        this.updateStatusPermission = false;
      }

      if (jsonPermissions.some(p => p.code === "DOMAIN_CHECK")) {
        this.checkPermission = true;
      }
      else {
        this.checkPermission = false;
      }
    },
    initSearchCriteria() {
      let isDefault = true;

      if (sessionHelper.hasSearchCriteria(SESSION.DOMAIN_SEARCH)) {
        isDefault = false;
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.DOMAIN_SEARCH);
        this.currentPage = this.searchCriteria.pageNumber;
        this.filter = this.searchCriteria.searchValue;
        this.selectedStatus = this.searchCriteria.isActive;
      }

      if (isDefault) {
        this.searchCriteria = {
          pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
          pageSize: SHARED.DEFAULT_PAGE_SIZE,
          isActive: this.statusDdl[0].value,
          searchValue: "",
          searchArray: [],
        };
      }

      if (this.readPermission == true) {
        this.getDomainList(this.searchCriteria);
      }
    },

    getDomainList(filter) {
      this.getAllDomains({ filter });
      this.searchCriteria = filter;
      sessionHelper.storeSearch(SESSION.DOMAIN_SEARCH, filter);
    },

    pageNavigation(pageNumber) {
      let filter = sessionHelper.retrieveSearch(SESSION.DOMAIN_SEARCH);
      filter.pageNumber = pageNumber;

      this.getDomainList(filter);
    },

    searchListing() {
      this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;

      this.searchCriteria.searchValue = this.filter;
      this.searchCriteria.searchArray = [];
      this.searchCriteria.searchArray.push(this.filter);
      this.searchCriteria.isActive = this.selectedStatus;
      if (this.filter == '' || this.filter == null) {
        this.searchCriteria.pageNumber = 1;
        this.currentPage = 1;
      }
      this.getDomainList(this.searchCriteria);
    },

    editStatus(domain) {
      const data = {
        uuid: domain.id,
        isActive: domain.isActive,
      };

      this.updateDomainStatus({ filter: this.searchCriteria, data });
    },

    requestCheck(domain) {
      if (this.checkPermission == true && !this.status.checking) {
        this.checkDomain({ uuid: domain.id, filter: this.searchCriteria });
      }
    },

    statusVariant(status) {
      // Colour says who has to act: red = a telco, dark = the registrar,
      // grey = DNS / hosting, yellow = a warning rather than an outage.
      return {
        OK: 'success',
        SUSPECT: 'warning',
        PARTIAL: 'warning',
        BLOCKED: 'danger',
        REAL_BLOCK: 'danger',
        ERROR_BLOCK: 'warning',
        REGISTRAR_SUSPENDED: 'dark',
        NOT_REGISTERED: 'dark',
        EXPIRED: 'dark',
        UNRESOLVABLE: 'secondary',
        SITE_DOWN: 'secondary',
        BROWSER_WARNING: 'warning',
        NO_DATA: 'light',
        ERROR: 'danger',
      }[status] || 'danger';
    },

    hasPlayerReports(row) {
      const f = row.recentFailures;
      return f != null && f.visitors > 0;
    },

    isDomainFault(status) {
      // Faults nobody's telco caused: the registrar, DNS or the origin. A
      // telco verdict (BLOCKED / REAL_BLOCK / ERROR_BLOCK / SUSPECT / OK)
      // comes from the monitor's vantage probes and is not shown here.
      return ['REGISTRAR_SUSPENDED', 'NOT_REGISTERED', 'EXPIRED', 'UNRESOLVABLE', 'SITE_DOWN', 'BROWSER_WARNING'].includes(status);
    },

    failureTooltip(f) {
      return (f.networks || []).map((n) => `${n.name}: ${n.failed}/${n.total}`).join(' · ') || '-';
    },

    statusLabel(status) {
      return this.$te('enumDomainStatus.' + status) ? this.$t('enumDomainStatus.' + status) : status;
    },

    warningLabel(warning) {
      const code = warning && warning.code;
      return this.$te('enumWarning.' + code) ? this.$t('enumWarning.' + code) : code;
    },

    formatDateTime(value) {
      return value ? moment(value).format(DATE.DATE_TIME_SHORT_TZ) : '-';
    },

    sinceDaysLabel(value) {
      if (!value) return '';
      const days = moment().startOf('day').diff(moment(value).startOf('day'), 'days');
      return this.$t('label.sinceDays', [days]);
    },

    toDetailsPage(id) {
      let filter = sessionHelper.retrieveSearch(SESSION.DOMAIN_SEARCH)
      filter.selectedRecordId = id
      sessionHelper.storeSearch(SESSION.DOMAIN_SEARCH, filter)

      this.$router.push({
        name: 'Domain-update'
      })
    },

    toResultsPage(id) {
      let filter = sessionHelper.retrieveSearch(SESSION.DOMAIN_SEARCH)
      filter.selectedRecordId = id
      sessionHelper.storeSearch(SESSION.DOMAIN_SEARCH, filter)

      this.$router.push({
        name: 'Domain-results'
      })
    },

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right" style="float: left">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("label.search") }}
                    <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                      class="form-control form-control-sm ml-2" @change="searchListing"></b-form-input>
                  </label>
                  <label class="d-inline-flex align-items-center ml-2">
                    {{ $t("label.status") }}
                    <multiselect v-model="selectedStatusOption" :options="statusDdl" label="text" track-by="value"
                      :show-labels="false" :allow-empty="false" class="ml-2" style="width: 180px; display: inline-block;"
                      @input="searchListing"></multiselect>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right" style="float: right">
                  <router-link tag="a" to="/domain/create" style="float: right; margin-bottom: 10px"
                    v-if="createPermission == true" class="btn btn-info w-md waves-effect waves-light">
                    {{ $t('label.createX', [$t('module.domain')]) }}
                  </router-link>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                v-if="readPermission == true">
                <template #cell(lastStatus)="data">
                  <!-- What real players reported through the player link, and
                       nothing else. The monitor's own telco reading (its
                       vantage probes) stays on the check results page; a fault
                       in the domain itself -- registrar hold, no DNS, site
                       down -- is not a telco reading and still belongs here. -->
                  <template v-if="hasPlayerReports(tableRows[data.index])">
                    <b-badge :variant="tableRows[data.index].recentFailures.failed > 0 ? 'danger' : 'success'" v-b-tooltip.hover
                      :title="failureTooltip(tableRows[data.index].recentFailures)">
                      {{ $t('label.playersFailedX', [tableRows[data.index].recentFailures.failed, tableRows[data.index].recentFailures.visitors, tableRows[data.index].recentFailures.window_minutes / 60]) }}
                    </b-badge>
                  </template>
                  <template v-else-if="isDomainFault(tableRows[data.index].lastStatus)">
                    <b-badge :variant="statusVariant(tableRows[data.index].lastStatus)">
                      {{ statusLabel(tableRows[data.index].lastStatus) }}
                    </b-badge>
                    <div class="text-muted small" v-if="tableRows[data.index].lastReason">
                      {{ tableRows[data.index].lastReason }}
                    </div>
                  </template>
                  <span v-else class="text-muted small">{{ $t('label.noPlayerData') }}</span>

                  <div v-if="tableRows[data.index].lastWarnings && tableRows[data.index].lastWarnings.length > 0">
                    <b-badge variant="warning" class="mr-1 mt-1" v-for="(warning, index) in tableRows[data.index].lastWarnings"
                      :key="index" v-b-tooltip.hover :title="warning.message">
                      {{ warningLabel(warning) }}
                    </b-badge>
                  </div>
                </template>

                <template #cell(problemDetectedAt)="data">
                  <template v-if="tableRows[data.index].problemDetectedAt">
                    {{ formatDateTime(tableRows[data.index].problemDetectedAt) }}
                    <div class="text-muted small">
                      {{ sinceDaysLabel(tableRows[data.index].problemDetectedAt) }}
                    </div>
                  </template>
                  <span v-else>-</span>
                </template>

                <template #cell(lastCheckedAt)="data">
                  {{ formatDateTime(tableRows[data.index].lastCheckedAt) }}
                </template>

                <template #cell(isActive)="data">
                  <b-form-checkbox @change="editStatus(tableRows[data.index])" v-model="tableRows[data.index].isActive"
                    switch class="mb-1" :disabled="updateStatusPermission == false">
                  </b-form-checkbox>
                </template>

                <template #cell(action)="data">
                  <a href="javascript:void(0);" class="text-info" @click="toDetailsPage(tableRows[data.index].id)"
                    v-b-tooltip.hover v-if="updatePermission == true" :title="$t('label.updateX', [$t('module.domain')])">
                    <i class="mdi mdi-pencil font-size-18"></i>
                  </a>

                  <a href="javascript:void(0);" style="margin-left: 5px;"
                    :class="status.checking ? 'disabled text-warning' : 'text-success'"
                    @click="requestCheck(tableRows[data.index])" v-b-tooltip.hover v-if="checkPermission == true"
                    :title="$t('label.checkNow')">
                    <b-spinner small v-if="status.checking == tableRows[data.index].id"></b-spinner>
                    <i class="mdi mdi-radar font-size-18" v-else></i>
                  </a>

                  <a href="javascript:void(0);" class="text-info" style="margin-left: 5px;"
                    @click="toResultsPage(tableRows[data.index].id)" v-b-tooltip.hover :title="$t('label.results')">
                    <i class="mdi mdi-history font-size-18"></i>
                  </a>
                </template>
              </b-table>
              <div style="text-align: center;" v-else>
                {{ $t('message.noPermissionMessage') }}
              </div>
            </div>
            <div class="row" v-if="this.readPermission == true">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalPage" :per-page="perPage"
                      @change="pageNavigation"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
a.disabled {
  pointer-events: none;
  cursor: default;
}
</style>
